import dataService from '../app.service'

const getSearch2Facets = (entityType = 'company') => {
  return dataService.get(`/search2/facets/${entityType}`)
}

const postSearch2 = data => {
  return dataService.post('/search2', data)
}

const getQuicksearch = (
  searchString,
  numberOfShownResults = 20,
  kind = ['company']
) => {
  let searchPayload = {
    count: numberOfShownResults,
    offset: 0,
    kind,
    query: {
      bool: {
        must: {
          multi_match: {
            query: searchString,
            fields: ['displayName', 'commonName'],
          },
        },
      },
    },
    sort: [
      {
        _score: {
          order: 'desc',
        },
      },
    ],
  }

  return dataService.post('/search2', searchPayload)
}

const getQuicksearchByKind = (
  searchString,
  kind = 'company',
  numberOfShownResults = 20
) => {
  let searchPayload = {
    count: numberOfShownResults,
    offset: 0,
    kind: [kind],
    query: {
      bool: {
        must: [
          {
            bool: {
              should: [{ bool: { filter: { terms: { _kind: [kind] } } } }],
            },
          },
          {
            bool: {
              should: [
                {
                  bool: {
                    must: {
                      multi_match: {
                        query: searchString,
                        fields: ['displayName'],
                      },
                    },
                  },
                },
              ],
            },
          },
        ],
      },
    },
    sort: [
      {
        _score: {
          order: 'desc',
        },
      },
    ],
  }

  return dataService.post('/search2', searchPayload)
}

export default {
  getSearch2Facets,
  postSearch2,
  getQuicksearch,
  getQuicksearchByKind,
}
